import TagManager from 'react-gtm-module'

export function sendAddExcursionGTM(priceChange: number, priceChangePerPerson: number, excursionName: string): void {
  TagManager.dataLayer({
    dataLayer: {
      event: 'add_excursion',
      total_price_change: priceChange,
      total_price_change_per_person: priceChangePerPerson,
      excursion_name: excursionName,
    },
  })
}
